module.exports = __webpack_public_path__ + "img/sy.51e8a017.png";